'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalDashedLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalDashedLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalDashedLine: React.FC<
  Omit<IVerticalLineProps, 'skin'>
> = props => {
  return <VerticalLine {...props} skin={VerticalDashedLineSkin} />;
};

export default VerticalDashedLine;
